import throttle from '@plugins/throttle';

export default () => {
  const $component = $('.breadcrumbs');
  const $instituteHero = Boolean($component.parents('.institutes-hero-content').length);

  if (!$component.length) {
    return;
  }

  $component.each((i, component) => {
    const $this = $(component),
          $menuItems = $this.find('.breadcrumbs-list-item'),
          $hasDropdown = $this.find('.-has-dropdown'),
          $scrollContainer = $this.find('.breadcrumbs-list');

    $hasDropdown.each((i, item) => {
      const $parent = $(item).parent(),
            $dropdown = $parent.find('.breadcrumbs-list-item-dropdown'),
            $links = $parent.find('a'),
            $buttons = $parent.find('button');

      $links.add($dropdown).add($buttons).on('click', () => {
        if (!isMobile()) {
          hoverClass($parent, true);
        }
      });

      // $(item).add($dropdown).add($buttons).on('mouseleave', () => {
      //   if (!isMobile()) {
      //     hoverClass($parent, false);
      //   }
      // });

      $buttons.on('click', (e) => {
        if (isMobile()) {
          if ($(e.target).parents('.-hovered').length) {
            $component.find('.-hovered').removeClass('-hovered');
          } else {
            $component.find('.-hovered').removeClass('-hovered');
            $parent.toggleClass('-hovered');
          }
        }
      });

      $links.on('focus', () => hoverClass($parent, true));

      $links.on('blur', () => hoverClass($parent, false));
      $buttons.on('blur', () => hoverClass($parent, false));

      $scrollContainer.on('scroll', throttle(() => {
        hoverClass($parent, false);
        addOverlay($scrollContainer);
      }));

      // if user scrolls, close dropdowns
      // $(window).on('scroll', throttle(() => {
      //   hoverClass($parent, false);
      // }));
    });

    setTimeout(() => {
      scrollToEnd($scrollContainer);
    }, 500);

    handleResize($menuItems, $this);
    $(window).on('resize', throttle(() => handleResize($menuItems, $this)));
  });

  function hoverClass($el, bool) {
    if (bool) {
      $el.addClass('-hovered');
    } else {
      $el.removeClass('-hovered');
    }
  }

  function scrollToEnd($el) {
    $el.animate({
      scrollLeft: $el[0].scrollWidth
    }, 1000);
  }

  function addOverlay($el) {
    if ($el.scrollLeft() > 30) {
      $component.addClass('-overlay');
    } else {
      $component.removeClass('-overlay');
    }
  }

  function isMobile() {
    return !$component.hasClass('-wide');
  }

  function handleResize($menuItems, $component) {
    let totalWidth = 0;

    $menuItems.each((i, item) => totalWidth += $(item).width());

    let goWide = window.innerWidth > totalWidth + 250;

    if ($instituteHero) {
      goWide = window.innerWidth > totalWidth + 350;
    }

    goWide ? $component.addClass('-wide') : $component.removeClass('-wide');
  }
};